import type { Dayjs } from 'dayjs';

import { dateTime } from '@/_shared';

import type { TSubscriptionType } from './types';

export function getRecurringPaymentStartDate(
  orgDate: string,
  subscriptionType: TSubscriptionType,
  notAddingNextPeriod = false
) {
  let recurringPaymentStartDate = dateTime.parse(orgDate);
  if (!notAddingNextPeriod && subscriptionType === 'monthly') {
    recurringPaymentStartDate = dateTime.add(recurringPaymentStartDate, 1, 'month');
  }

  if (!notAddingNextPeriod && subscriptionType === 'bi-weekly') {
    recurringPaymentStartDate = dateTime.add(recurringPaymentStartDate, 14, 'day');
  }

  if (subscriptionType === 'monthly') {
    recurringPaymentStartDate = dateTime.getMonthlyPaymentDate(recurringPaymentStartDate.toISOString(), false) as Dayjs;
  }

  return recurringPaymentStartDate.toISOString();
}

export function getRecurringPaymentDateLimits(orgDate: string, calculatedDate: string) {
  const max = dateTime.add(calculatedDate, 14, 'day').toISOString();
  const min = dateTime.add(orgDate, 1, 'day').toISOString();
  return { max, min };
}

export function getRecurringPaymentStartSentence(date: string, subscriptionType: TSubscriptionType) {
  const nDate = dateTime.parse(date);
  return `${
    subscriptionType === 'monthly' ? 'Monthly' : `Every other ${nDate.format('dddd')}`
  }, Starting ${nDate.format('MMMM DD, YYYY')}`;
}

export const calcStartPaymentDateAndLimits = (lastData: string, subscriptionType: TSubscriptionType) => {
  const recurringPaymentStartDate = getRecurringPaymentStartDate(lastData, subscriptionType);
  const recurringPaymentDateLimits = getRecurringPaymentDateLimits(lastData, recurringPaymentStartDate);
  return { recurringPaymentStartDate, recurringPaymentDateLimits };
};
